import axios from "axios";
import { buildAxiosAuthenticationHeaders } from "../util/build-axios-authentication-headers";
import { querytimescaleUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";
import { parseAxiosApiError } from "@src/cloud-connect/utils/parse-axios-api-error";

export interface ActiveTimeseriesParams {
  namespace: string;
  sourceId: string;
}

export const getActiveTimeseries = async ({
  namespace,
  sourceId,
}: ActiveTimeseriesParams) => {
  const url = querytimescaleUrlEnvVar();
  const headers = buildAxiosAuthenticationHeaders();

  try {
    const response = await axios.get(
      `${url}/api/v3/tsdata/ns/${namespace}/source/${sourceId}/active-timeseries`,
      {
        headers,
      },
    );

    return {
      success: true,
      data: response.data,
    };
  } catch (error) {
    const { message, status } = parseAxiosApiError(
      error,
      "Failed to fetch active timeseries data",
    );

    return {
      success: false,
      error: message,
      status,
    };
  }
};
